
const initialState = {
	isEditingInProgress: false,
}

export const AppReducer = (state = initialState, action = {}) => {    
   switch (action.type) {
        case 'IS_EDITING_IN_PROGRESS':
        	return {
                isEditingInProgress: {...state.isEditingInProgress,[action.name]: action.value}
            }
        case 'DESTROY':
            return initialState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/AppReducer.js